import { forwardRef, type InputHTMLAttributes } from "react";

import { cx } from "../lib/format";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  /** Mono face for IDs, phone numbers, precise values. */
  mono?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, mono = false, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cx(
        "h-9 w-full rounded border bg-surface px-3 text-sm text-bright placeholder:text-muted",
        "transition-colors focus:outline-none",
        invalid ? "border-danger" : "border-line focus:border-muted",
        "disabled:cursor-not-allowed disabled:opacity-50",
        mono && "font-mono",
        className,
      )}
      {...rest}
    />
  );
});
